export default __webpack_public_path__ + "static/codeplatform-ai-0-e5b7e45ce6f5919fe1fd1c527d68068a.png";